module.exports = __webpack_public_path__ + "img/jramjsLogo.9bdf5ac5.png";